import { TransferTypesPanel } from "@/components/organisms";
import { TransferTypesAdd } from "./TransferTypesAdd";
import { TransferTypesEdit } from "./TransferTypesEdit";

export const TransferTypes = () => {
  return <TransferTypesPanel />;
};

TransferTypes.Edit = TransferTypesEdit;
TransferTypes.Add = TransferTypesAdd;
